import React from 'react';
import MenuProductosItem from './MenuProductosItem';

const MenuItemNodes = ({ menuUsuario }) => {
    if (menuUsuario === undefined || menuUsuario === null)
        return null;

    const productItems = menuUsuario.map((product) =>
        <MenuProductosItem
            categorias={product.categorias}
            ruta={product.codigo}
            codigo={product.codigo}
            id={product.id}
            key={product.id}
        />
    );

    return (
    <ul className="dropdown-menu">
        {productItems}
    </ul>
   );
}

export default MenuItemNodes;



// WEBPACK FOOTER //
// ./Portico/App/Screens/MenuProductos/components/MenuItemNodes.js